var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, firstImageProperty } from '@shapeable/utils';
var cls = classNames('person-image');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from '../elements/icon';
import { ImageBubble } from '../elements/image-bubble';
import { TextBubble } from '../elements/text-bubble';
import { EntityLink } from './entity-link';
import { initials } from '@shapeable/utils';
import { filter } from 'lodash';
export var PersonImageDefaultProps = {
  link: false,
  border: false,
  showImage: true
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-shrink: 0;\n\n    img {\n      object-fit: cover;\n    }\n  "], ["\n    flex-shrink: 0;\n\n    img {\n      object-fit: cover;\n    }\n  "])))
});
var ImageBubbleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (props) {
    return props._link && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      transition: filter 0.3s;\n      &:hover {\n        filter: brightness(110%);\n      }\n    "], ["\n      transition: filter 0.3s;\n      &:hover {\n        filter: brightness(110%);\n      }\n    "])));
  }, function (props) {
    return props.border && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      transition: border-color 0.3s;\n      ", "\n    "], ["\n      border: 1px solid ", ";\n      transition: border-color 0.3s;\n      ", "\n    "])), theme.COLOR('line-subtle'), function (props) {
      return props._link && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        &:hover {\n          border-color: ", ";\n        }\n      "], ["\n        &:hover {\n          border-color: ", ";\n        }\n      "])), theme.COLOR('link'));
    });
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var InitialsStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (props) {
    return props._link && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: 100%;\n      height: 100%;\n      &:hover {\n        border-color: ", ";\n      }\n    "], ["\n      width: 100%;\n      height: 100%;\n      &:hover {\n        border-color: ", ";\n      }\n    "])), theme.COLOR('link'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled(EntityLink)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ImageBubble: styled(ImageBubble)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageBubbleStyles),
  Icon: styled(Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Initials: styled(TextBubble)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), InitialsStyles)
};
export var PersonImage = function (props) {
  var className = props.className,
    entity = props.entity,
    size = props.size,
    link = props.link,
    showImage = props.showImage,
    transform = props.transform;
  var Container = link ? My.Link : My.Container;
  var containerProps = link ? {
    entity: entity
  } : {
    entity: null
  };
  var image = firstImageProperty(entity, filter([transform, 'photo', 'openGraph.image']));
  var bubbleInitials = entity.slug ? initials(entity.name) : '?';
  return React.createElement(Container, __assign({}, containerProps, {
    className: cls.name(className)
  }), image && showImage ? React.createElement(My.ImageBubble, {
    size: size,
    image: image
  }) : React.createElement(My.Initials, {
    colors: {
      border: 'sub',
      text: 'sub'
    },
    size: size,
    _link: link
  }, bubbleInitials));
};
PersonImage.defaultProps = PersonImageDefaultProps;
PersonImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;